let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("MG9xA")).then(() => parcelRequire('4QiA1'));